import { FLAG_MEDIA_DOMAIN } from '@lib/tools/shared/helpers/consts';

import GlobeIcon from '@components/web/src/assets/icons/icon_globe.svg';
import { CaretDownIcon } from '@components/web/src/atoms/Icons/CaretDownIcon';
import { Image } from '@components/web/src/foundations/Image/Image';
import { Text } from '@components/web/src/foundations/Text/Text';
import * as S from '@components/web/src/organisms/LanguageSwitcher/styles';
import { COLORS } from '@components/web/src/styles';

interface Props {
  languageCode: string;
  languageText: string;
  showLanguagesList?: boolean;
  isListItem?: boolean;
  handleSelectLanguage: (code: string) => void;
  handleToggleLanguagesList?: () => void;
}

const LanguageItem = ({
  languageCode,
  languageText,
  isListItem = false,
  showLanguagesList = false,
  handleSelectLanguage,
  handleToggleLanguagesList,
}: Props) => {
  const flagCode = languageCode === 'en' ? 'GB' : languageCode;
  const flagSrc = !isListItem ? GlobeIcon : `${FLAG_MEDIA_DOMAIN}${flagCode.toUpperCase()}.png`;

  return (
    <S.LanguageItemContainer
      $isListItem={isListItem}
      $showLanguageList={showLanguagesList}
      align="center"
      gap={isListItem ? 10 : 8}
      justify="flex-start"
      onClick={() => {
        handleSelectLanguage(languageCode);
        if (handleToggleLanguagesList) handleToggleLanguagesList();
      }}
    >
      <Image alt="flag" height="20px" src={flagSrc} width="20px" />
      <Text color={COLORS.gray['900']} size="body2" text={languageText || languageCode} weight="medium" />
      {!isListItem && <CaretDownIcon fillColor={COLORS.base.black} />}
    </S.LanguageItemContainer>
  );
};

export default LanguageItem;
